require('./bootstrap');

let http = require('./http');

let success = function (response) {
    
    if (response.redirect) {
        window.location.href = response.redirect;
    }

    if (response.reload) {
        window.location = window.location;
    }

    if (response.callback) {
        window.location.href = response.callback;
    }
}

let errors = function (errors) {
    console.log(errors);
}

export const initClientScripts = function () {

    $(document).on('submit', 'form.client-form', function (e) {
        e.preventDefault();
        
        let form = $(this);
        let url = form[0].action;
        let method = form[0].method;
        let data = new FormData(form[0]);

        let button = form.find('button');
        button.attr('disabled', 'true');
        button.html('<i class="fa fa-cog fa-spin spinner"></i>');

        $('input[type=checkbox].rental-item').each(function (e) {
            $(this).attr('disabled', 'disabled');
        });

        form.attr('disabled', 'disabled');

        http.sendAjax(url, method, data, success, errors);
    });

    $(document).on('click', '.remove-rental-order-item', function (e) {
        confirm('Are you sure you want to delete this?');
        $(this).html('<i class="fa fa-cog fa-spin red"></i>');

        let data = new FormData();
        data.set('rental_order', $(this).data('rental-order'))
        data.set('gear_item', $(this).data('gear-item'));

        let rental_order = $(this).data('rental-order');

        let url = '/client/rental/' + rental_order + '/removeItem';

        http.sendAjax(url, 'post', data, success, errors);
    });

    $(document).on('click', '.available-rental-item', function (e) {
        let gear_id = $(this).data('gear-id');
        if ($(this).is(':checked')) {
            $('.available-gear-options').each(function () {
                if ($(this).data('parent') === gear_id) {
                    $(this).removeClass('hide');
                }
            });
        } else {
            $('.available-gear-options').each(function () {
                if ($(this).data('parent') === gear_id) {
                    $(this).addClass('hide');
                }
            });
        }
    });

    $(document).on('click', '.edit-rental-order-item', function (e) {
        let rental_order_item = $(this).data('rental_order-item');
        
        $('.edit-rental-order-item-details').each(function () {
            if ($(this).data('parent') === rental_order_item) {
                $(this).removeClass('hide');
            }
        });
    });

    $(document).on('click', '.edit-profile', function (el) {
        
        $(this).closest(':has(.profile-data)').find('.profile-data').toggle();
        $(this).closest(':has(.edit-form)').find('.edit-form').toggle();

        let form = $(this).closest(':has(.profile-form)').find('.profile-form');

        form[0].reset();
    });

    $(document).on('submit', 'form.profile-form', function (el) {

        el.preventDefault();

        let form = $(this);
        let url = form[0].action;
        let method = form[0].method;
        let data = new FormData(form[0]);
        let button = form.find('button.submit-button');
        let cancelButton = form.find('button.edit-profile');

        button.attr('disabled', 'true');
        cancelButton.attr('disabled', true);

        button.html('<i class="fa fa-cog fa-spin spinner"></i>');

        form.attr('disabled', 'disabled');

        http.sendAjax(url, method, data, success, errors);
    });

    $(document).on('click', '.card.trip-register-program', function () {

        $('.card.trip-register-program').each(function () {
            if ($(this).hasClass('active-program')) {
                $(this).removeClass('active-program')
            }
        });

        $(this).addClass('active-program');

        let programs = $(this).data('program').split(',').map(Number);

        $('.trip-registration-trip').each(function () {
            if (!programs.includes($(this).data('program'))) {
                $(this).toggleClass('hide');
            }
        });

        let content = $(this).data('content');

        $('.terms-conditions, .AAI-release, .national-park-release').each(function () {
            if ($(this).data('content') == content) {
                $(this).toggleClass('hide');
            } else {
                $(this).addClass('hide');
            }
        });
    });

    $(document).on('change', '#documentType', function () {
        if ($(this).val() != '') {
            $('#document-upload-container').removeClass('hide');
        } else {
            $('#document-upload-container').addClass('hide');
            $('#documentUpload').val('');
        }
    });

    $(document).on('change', '#documentUpload', function () {
        if ($(this).val() != '') {
            $('#document-upload-submit-container').removeClass('hide');
        } else {
            $('#document-upload-submit-container').addClass('hide');
        }
    });

    $(document).on('change', '#clientBillingSame', function () {
        if ($(this).is(':checked')) {
            $('#clientBillingAddressFields').addClass('hide');
        } else {
            $('#clientBillingAddressFields').removeClass('hide');
        }
    });

    $(document).on('submit', '#client-update-terms-release', function (el) {

        el.preventDefault();

        let form = $(this);
        let url = form[0].action;
        let method = form[0].method;
        let data = form.serialize();
        let button = form.find('button');

        button.attr('disabled', 'true');
        button.html('<i class="fa fa-cog fa-spin spinner"></i>');

        form.attr('disabled', 'disabled');

        function success(response) {
            if (response.redirect) {
                window.location.replace(response.redirect);
            } else {
                button.html('Submit Forms');
                button.attr('disable', 'false');
                form.attr('disabled', 'false');
            }
        }

        $.post(url, data, success, 'json');
    });

    $(document).on('click', '#clientSendAccountInfo', function (el) {
        el.preventDefault();
        console.log("Click");
        $(this).attr('disabled', 'true');
        $(this).html('<i class="fa fa-cog fa-spin spinner"></i>');

        const url = el.target.dataset.url,
            data = {};
        
        function success(response) {
            window.location.reload();
        }

        $.post(url, data, success, 'json');
    })

}